import { useTranslation } from 'react-i18next';
import "../../styles/sidebar/sidebar.css";

export default function DocInfoCard({ totalFiles, totalSize, maxSize }) {
    const formatSize = (sizeInMB) => {
        if (sizeInMB < 1) {
            return `${(sizeInMB * 1024).toFixed(0)} KB`;
        }
        return `${sizeInMB?.toFixed(2)} MB`;
    };
    const { t } = useTranslation();
    return (
        <div className="doc-info-card">
            <h4>{t('doc-info')}</h4>
            <div className="stats">
                <div className="stat">
                    <span className="label">{t('total-file')} {t('colon')} </span>
                    <span className="value">{totalFiles} {t('files')}</span>
                </div>
                <div className="stat">
                    <span className="label">{t('total-size')} {t('colon')} </span>
                    <span className="value">
                        {formatSize(totalSize)}
                    </span>
                </div>
            </div>
        </div>
    );
};